__turbopack_context__.v({
  "bar": "CookieConsent-module__ORNcuG__bar",
  "button": "CookieConsent-module__ORNcuG__button",
  "link": "CookieConsent-module__ORNcuG__link",
  "text": "CookieConsent-module__ORNcuG__text",
});
